import { X } from 'lucide-react';
import type { TerminalWithHeartbeat } from './types';

interface TerminalDetailsModalProps {
  terminal: TerminalWithHeartbeat;
  onClose: () => void;
}

export default function TerminalDetailsModal({ terminal, onClose }: TerminalDetailsModalProps) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="card max-w-lg w-full mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-gray-900">Terminal Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Close modal"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between pb-4 border-b">
            <div>
              <h3 className="text-lg font-semibold">{terminal.name}</h3>
              <p className="text-sm text-gray-500 font-mono">{terminal.terminalId}</p>
            </div>
            <span
              className={`badge ${terminal.isOnline ? 'badge-success' : 'badge-danger'}`}
            >
              {terminal.status}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">Location</span>
              <p className="font-medium">{terminal.location}</p>
            </div>
            <div>
              <span className="text-gray-500">IP Address</span>
              <p className="font-mono">{terminal.ipAddress || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">MAC Address</span>
              <p className="font-mono">{terminal.macAddress || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">Software Version</span>
              <p className="font-medium">{terminal.appVersion || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">Device Model</span>
              <p className="font-medium">{terminal.deviceModel || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">OS Version</span>
              <p className="font-medium">{terminal.osVersion || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">Active</span>
              <p className="font-medium">{terminal.active ? 'Yes' : 'No'}</p>
            </div>
            <div className="col-span-2">
              <span className="text-gray-500">Last Heartbeat</span>
              <p className={`font-medium ${terminal.isOnline ? 'text-green-600' : 'text-red-600'}`}>
                {terminal.lastHeartbeatDistance || 'Never'}
              </p>
            </div>
            <div>
              <span className="text-gray-500">Registered</span>
              <p className="font-medium">
                {terminal.registrationDate ? new Date(terminal.registrationDate).toLocaleDateString() : 'N/A'}
              </p>
            </div>
            <div>
              <span className="text-gray-500">Last Updated</span>
              <p className="font-medium">
                {terminal.modifiedDate ? new Date(terminal.modifiedDate).toLocaleDateString() : 'N/A'}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <button onClick={onClose} className="btn btn-outline w-full h-10">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
